import {CookieManager} from '../../modules/cookie.js';
import {applyImageLightbox} from '../../modules/imageLightbox.js';
import {Auth} from '../../modules/auth.js';
import {injectTableOfContents} from '../../modules/tableOfContentsInjector.js';
import '../../components/cards/course.js';

/**
 * Add social signal for promoting 'Why Join IxDF' page.
 */
function registerSocialSignals() {
    const COOKIE_NAME = 'why_join_us_popup_dismissed';
    const isSignalDismissed = !!CookieManager.read(COOKIE_NAME);

    if (!isSignalDismissed) {
        // Get number of reasons (7/8) to join IxDF
        const numberOfReasons = /** @type {HTMLElement} */(document.querySelector('[data-reasons-number]')).dataset.reasonsNumber;

        import('../../modules/socialSignal.js').then(({SocialSignal}) => {
            setTimeout(() => {
                // If a modal is open, wait 5 sec and try again. It's because
                // these social signals and modals can't be open simultaneously.
                const openedDialog = document.querySelector('dialog[open]');
                if (openedDialog) {
                    openedDialog.addEventListener('close', registerSocialSignals, {once: true});
                } else {
                    SocialSignal.info(`Want ${numberOfReasons} reasons to join our community?`, null, {
                        socialSignalClass: ['socialSignal', 'socialSignal--link'],
                        onClose: function () {
                            CookieManager.write(COOKIE_NAME, 1, {
                                days: 90,
                            });
                        },
                        onclick: function () {
                            CookieManager.write(COOKIE_NAME, 1, {
                                days: 90,
                            });
                            window.location.href = '/why-join-us'; // @route 'why-join-us.index'
                        },
                    });
                }
            }, 5000);
        });
    }
}

/**
 * Add available upcoming courses' cards into the sidebar.
 *
 * @param {string} publicationType
 * @param {string} publicationId
 */
function injectCourseAd(publicationType, publicationId) {
    Promise.resolve(import('../../modules/courseAdLocator.js')).then(({getInjectableElements}) => {
        const containers = getInjectableElements(document.querySelector('.js-courseAd-area'));
        if (containers.length) {
            return Promise.all([import('../../modules/courseAdInjector.js'), import('../../modules/courseAdReviver.js')]).then(
                ([{addCourseAd}, {runAllCountdowns}]) => {
                    addCourseAd(containers, publicationType, publicationId).then((adsBlocks) =>
                        runAllCountdowns(adsBlocks)
                    );
                }
            );
        }
    });
}

/** [no description; please add] */
function injectBannerAds() {
    const adAreas = document.querySelectorAll('.uxArticle__rteContent > ixdf-ad-area');

    if (adAreas?.length) {
        return;
    }

    const paragraphs = document.querySelectorAll('.uxArticle__rteContent > p');

    if (paragraphs.length <= 3) {
        return;
    }

    const target = paragraphs[2];
    const adComponent = document.createElement('ixdf-ad-area');
    adComponent.setAttribute('location', 'banner');

    target.parentElement.insertBefore(adComponent, target.nextSibling);
}
/**
 * Init page, register event handlers
 */
function initPage() {
    // If the user is a guest, display Social Signals
    if (Auth.guest()) {
        registerSocialSignals();
    }

    /** @type {HTMLElement|null} */
    const articleContainer = document.querySelector('.js-publicationContent');

    if (articleContainer) {
        injectTableOfContents(articleContainer, '.rteContent');
    }

    injectBannerAds();

    /*
     * Get if it's been defined in the view to
     * display the upcoming courses.
     */
    const doWeNeedToShowUpcomingCourses = /** @type {HTMLInputElement} */ (document.getElementById('js-showUpcomingCourses')).value === 'show';

    if (doWeNeedToShowUpcomingCourses) {
        // Get current publication type and id.
        let publicationType = /** @type {HTMLInputElement} */ (document.getElementById('js-publicationType')).value;
        let publicationId = /** @type {HTMLInputElement} */ (document.getElementById('js-publicationId')).value;

        // Inject course ad from the publication type and id
        injectCourseAd(publicationType, publicationId);
    }

    // Make all images in content has lightbox feature, but images in the any widget
    applyImageLightbox(
        [...document.querySelectorAll('.js-publicationContent :is(img, video.video-gif):not(.rteContent__isolatedBlock)')]
    );
}

// init page when the document is ready
document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initPage) : initPage();
